import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../../ui";
import { TableMonthCellContainer, TableMonthIconContainer } from "./styled";
export const TableMonthCell = ({ ...props }) => {
    return (_jsx(TableMonthCellContainer, { ...props, children: _jsx(TableMonthIconContainer, { children: _jsx(Icon, { icon: "check", size: 8 }) }) }));
};
